import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    is_mentor: '',
    subject: '',
    gender: '',
    created_at_from: '',
    created_at_to: '',
    birthday_from: '',
    birthday_to: '',
  },
}

export const teachersUI = createSlice({
  name: 'teachersUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setIsMentor: (state, { payload }) => {
      state.tableFilters.is_mentor = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setGender: (state, { payload }) => {
      state.tableFilters.gender = payload
    },
    setCreatedAtFromDate: (state, { payload }) => {
      state.tableFilters.created_at_from = payload
    },
    setCreatedAtToDate: (state, { payload }) => {
      state.tableFilters.created_at_to = payload
    },
    setBirthdayFromDate: (state, { payload }) => {
      state.tableFilters.birthday_from = payload
    },
    setBirthdayToDate: (state, { payload }) => {
      state.tableFilters.birthday_to = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setIsMentor,
  setSubject,
  setGender,
  setCreatedAtFromDate,
  setCreatedAtToDate,
  setBirthdayFromDate,
  setBirthdayToDate,
  trackActiveFilters,
  clearAllFilters,
} = teachersUI.actions

export default teachersUI.reducer
